exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PlatformIcon.fa-wordpress {\n  color: #26749b;\n}\n.PlatformIcon.fa-instagram {\n  color: #9f39a4;\n}\n.PlatformIcon.fa-youtube-play {\n  color: #cc2327;\n}\n.PlatformIcon.icon-betterhype:after {\n  content: '\\270C\\FE0F';\n  /*color: #CC2327;*/\n}\n", ""]);

// exports
